/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import deviceCredentials from 'components/DeviceCredentials/reducer';
import settingsDiscoverySeedReducer from 'components/DiscoverySeed/reducer';
import jobManagement from 'containers/App/Header/JobManagement/reducer';
import confirmDialogReducer from 'containers/ConfirmDialog/reducer';
import fileUploadOverlay from 'containers/FileUploadOverlay/reducer';
import languageProviderReducer from 'containers/LanguageProvider/reducer';
import leaveDialogue from 'containers/LeaveDialogue/reducer';
import toasterReducer from 'containers/Toaster/reducer';
import dashboardOverview from 'pages/Dashboard/Overview/reducer';
import administrationLdapSettings from 'pages/Settings/Administration/LdapSettings/reducer';
import settingsConfigurationManagement from 'pages/Settings/ConfigurationManagement/reducer';
import certificationAuthoritiesReducer from 'pages/Settings/System/BackupMaintenance/CertificationAuthorities/reducer';
import settingsSystemBackupMaintenance from 'pages/Settings/System/BackupMaintenance/reducer';
import snapshotManagement from 'pages/SnapshotManagement/reducer';
import supportDiagnosticsReducer from 'pages/Support/SendDiagnostics/reducer';
import supportVpnReducer from 'pages/Support/Vpn/reducer';
import { reducer as formReducer } from 'redux-form/immutable';
import { combineReducers } from 'redux-immutable';

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
const createRootReducer = (routerReducer) => {
  return combineReducers({
    ca: certificationAuthoritiesReducer,
    confirmDialog: confirmDialogReducer,
    dashboardOverview,
    deviceCredentials,
    fileUploadOverlay,
    form: formReducer,
    jobManagement,
    language: languageProviderReducer,
    leaveDialogue,
    notifications: toasterReducer,
    router: routerReducer,
    settingsConfigurationManagement,
    settingsSystemBackupMaintenance,
    settingsDiscoverySeed: settingsDiscoverySeedReducer,
    snapshotManagement,
    supportDiagnostics: supportDiagnosticsReducer,
    supportVpn: supportVpnReducer,
    administrationLdapSettings,
  });
};

export default createRootReducer;
